'use strict';

var React = require('react');

module.exports = function (props) {
    return React.createElement('svg', Object.assign({ viewBox: '0 0 1024 1024' }, props), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M704 832l288-288-288-288v192h-448v192h448v192z' }),
        React.createElement('path', { d: 'M64 64h704v128h-640v704h640v128h-704c-35.346 0-64-28.654-64-64v-832c0-35.346 28.654-64 64-64z' })
    ));
};